import { render } from "./Multiselect.vue?vue&type=template&id=301e535f"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"

import "./Multiselect.vue?vue&type=style&index=0&id=301e535f&lang=css"
script.render = render

export default script